<template>
  <div v-if="isShow && data" class="node-config-wrap">
    <!-- <p v-if="['report'].includes(nodeName)">截止提交时间：{{ showObj.submit_end_time || '--' }}</p> -->
    <p v-if="showObj.remark" class="remark">{{ showObj.remark }}</p>
    <p v-if="showObj.admin_remark" class="remark">{{ showObj.admin_remark }}</p>
  </div>
</template>

<script setup>
import API from '@/api'
import Router from '@/router'
import { Message } from 'element-ui'
import { computed, onMounted, reactive, ref } from 'vue'

const props = defineProps({
  // 子节点的属性名
  childNode: {
    type: String,
    default: ''
  }
})

const nodeName = computed(() => {
  return props.childNode
})

// 节点
const processName = ref(Router.currentRoute.name.toLowerCase())

const isShow = ref(false)

// 接口返回的数据
const data = ref('')

const showObj = reactive({
  submit_end_time: '',
  remark: ''
})

function getData() {
  API.MBAThesisNodeConfig(processName.value).then(res => {
    if (+res.code === 200) {
      data.value = res.data.info.content || null
      if (res.data.info && res.data.info.content) {
        // 设置节点显示的信息
        for (const key in showObj) {
          if (Object.hasOwnProperty.call(showObj, key)) {
            showObj[key] = res.data.info.content[key]
            // 如果有子节点，则显示子节点对应的信息
            if (nodeName.value && res.data.info.content[nodeName.value]) {
              showObj[key] = res.data.info.content[nodeName.value][key]
            }
          }
        }
      }

      isShow.value = true
    } else {
      Message.error(res.msg)
    }
  })
}

defineExpose({ getData })

onMounted(() => {
  getData()
})
</script>

<style lang="scss" scoped>
.remark {
  white-space: pre-wrap;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ccc;
}
</style>
